import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card, Button, EmptyState, Spinner } from "@/components/ui";
import { fmtDateTime } from "@/lib/helpers";
import { Mail, MailOpen } from "lucide-react";
import { toast } from "sonner";

export default function Inbox() {
  const [items, setItems] = useState(null);

  const load = useCallback(async () => { const r = await api.messagesInbox(); setItems(r.items || []); }, []);
  useEffect(() => { load(); }, [load]);

  const markRead = async (id) => { await api.messagesMarkRead(id); await load(); };
  const markAll = async () => { await api.messagesMarkAllRead(); await load(); toast.success("All marked read"); };

  if (!items) return <Spinner />;
  const unread = items.filter((m) => !m.read).length;

  return (
    <div className="kb-fade-up">
      <PageHeader eyebrow="Messages" title="Inbox"
        action={unread > 0 && <Button variant="secondary" data-testid="mark-all-read" onClick={markAll}>Mark all read</Button>} />

      {items.length === 0 ? (
        <Card><EmptyState testid="inbox-empty" icon={Mail} title="No messages yet"
          body="Messages from your KinBridge advocate about your claims will appear here." /></Card>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <Card key={m.id} data-testid={`message-${m.id}`} className={m.read ? "" : "border-brand"}>
              <div className="flex items-start gap-3">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${m.read ? "bg-brand-tint" : "bg-brand"}`}>
                  {m.read ? <MailOpen className="w-4 h-4 text-brand-dark" /> : <Mail className="w-4 h-4 text-white" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-ink">{m.subject || "Message"}</span>
                    {!m.read && <span className="w-2 h-2 rounded-full bg-mint shrink-0" />}
                  </div>
                  <div className="text-xs text-subtle">{m.from_admin_name}{m.provider ? ` · re: ${m.provider}` : ""} · {fmtDateTime(m.created_at)}</div>
                  <p className="text-sm text-ink mt-2 whitespace-pre-line">{m.body}</p>
                  {!m.read && (
                    <button data-testid={`mark-read-${m.id}`} onClick={() => markRead(m.id)} className="text-sm text-brand font-semibold mt-2 hover:underline">Mark as read</button>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
